<div class="anc-bulk-bar">
    <span class="anc-bulk-bar__count">{{ count() }} {{ itemLabel() | translate }} {{ 'Selected' | translate }}</span>

    <span class="anc-bulk-bar__divider"></span>

    <div class="anc-bulk-bar__actions">
        @for (action of visibleActions(); track action.id) {
            <button
                type="button"
                class="anc-bulk-bar__btn"
                (click)="onActionClick(action.id)"
            >{{ action.label }}</button>
        }
    </div>

    

    @if (hasOverflowActions()) {
        <div
            ngbDropdown
            class="anc-bulk-bar__more"
            display="dynamic"
            container="body"
            placement="top-end"
            [popperOptions]="popperOptions"
        >
            <button
                type="button"
                class="anc-bulk-bar__more-trigger"
                ngbDropdownToggle
                aria-label="More bulk actions"
            >
                <span class="icon icon--24 icon-more-menu" aria-hidden="true"></span>
            </button>

            <div ngbDropdownMenu class="anc-action-menu__list">
                @for (action of overflowActions(); track action.id) {
                    <button
                        type="button"
                        ngbDropdownItem
                        class="anc-action-menu__item"
                        (click)="onActionClick(action.id)"
                    >{{ action.label }}</button>
                }
            </div>
        </div>
    }

    <span class="anc-bulk-bar__divider"></span>
    <button
        type="button"
        class="anc-bulk-bar__close"
        aria-label="Clear selection"
        (click)="onDismiss()"
    >
        <span class="icon icon-x" aria-hidden="true"></span>
    </button>
</div>
